<template>
    <v-card class="elevation-12">
        <v-toolbar dark color="primary">
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <div style="height: 5px;">
            <v-progress-linear v-show="loading" class="ma-0" height="5" color="secondary"
                               :indeterminate="true"></v-progress-linear>
        </div>
        <v-card-text>
            <slot></slot>
            <div class="error--text">
                {{error}}
            </div>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" :disabled="!valid || loading" color="primary">{{action}}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  name: 'CardForm',
  props: {
    title: {
      type: String,
      default: 'Authentication'
    },
    action: {
      type: String,
      default: 'Ok'
    },
    error: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    }
  },
}
</script>
